// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.projects-main {
  width: 100%;
  text-align: center;
}

.basic-projects {
  margin-left: 5%;
  margin-right: 5%;
}

.projects-heading-div {
  display: flex;
}

.projects-heading-div > * {
  flex: 1 1;
}

.projects-heading-img-div {
  align-items: center;
  justify-content: center;
}

.projects-heading-text-div {
  text-align: center;
}

.projects-heading-img-div > * {
  max-width: 100%;
  height: auto;
}

.projects-heading-text {
  font-size: 56px;
  font-weight: 400;
  font-family: "Be Vietnam Pro", sans-serif;
  line-height: 1.1;
  text-align: center;
  margin-top: 80px;
}

.projects-heading-sub-text {
  font-size: 30px;
  font-family: "Be Vietnam Pro", sans-serif;
  text-align: center;
  margin-bottom: 10px;
}

.projects-header-detail-text {
  font-size: 20px;
  line-height: 30px;
  margin-top: 0px;
  margin-left: 20px;
  margin-right: 20px;
  font-family: "Be Vietnam Pro", sans-serif;
}

.repo-cards-div-main {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(400px, 1fr));
  gap: 1rem 1rem;
  margin-left: 40px;
  margin-right: 40px;
  margin-top: 60px;
}

@media (max-width: 1380px) {
  .projects-heading-text {
    font-size: 50px;
    margin-top: 80px;
  }
  .projects-heading-sub-text {
    font-size: 25px;
  }
}

@media (max-width: 768px) {
  .projects-heading-text {
    font-size: 30px;
    margin-top: 20px;
  }

  .projects-heading-sub-text {
    font-size: 20px;
  }

  .projects-heading-div {
    flex-direction: column;
  }

  .projects-header-detail-text {
    font-size: 16px;
    margin-right: 0px;
    margin-left: 0px;
    line-height: normal;
    text-align: center;
  }

  .repo-cards-div-main {
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
    margin-left: 10px;
    margin-right: 10px;
    margin-top: 30px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/projects/Projects.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yCAAyC;EACzC,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,yCAAyC;EACzC,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE;IACE,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,2DAA2D;IAC3D,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;EAClB;AACF","sourcesContent":[".projects-main {\n  width: 100%;\n  text-align: center;\n}\n\n.basic-projects {\n  margin-left: 5%;\n  margin-right: 5%;\n}\n\n.projects-heading-div {\n  display: flex;\n}\n\n.projects-heading-div > * {\n  flex: 1;\n}\n\n.projects-heading-img-div {\n  align-items: center;\n  justify-content: center;\n}\n\n.projects-heading-text-div {\n  text-align: center;\n}\n\n.projects-heading-img-div > * {\n  max-width: 100%;\n  height: auto;\n}\n\n.projects-heading-text {\n  font-size: 56px;\n  font-weight: 400;\n  font-family: \"Be Vietnam Pro\", sans-serif;\n  line-height: 1.1;\n  text-align: center;\n  margin-top: 80px;\n}\n\n.projects-heading-sub-text {\n  font-size: 30px;\n  font-family: \"Be Vietnam Pro\", sans-serif;\n  text-align: center;\n  margin-bottom: 10px;\n}\n\n.projects-header-detail-text {\n  font-size: 20px;\n  line-height: 30px;\n  margin-top: 0px;\n  margin-left: 20px;\n  margin-right: 20px;\n  font-family: \"Be Vietnam Pro\", sans-serif;\n}\n\n.repo-cards-div-main {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(400px, 1fr));\n  gap: 1rem 1rem;\n  margin-left: 40px;\n  margin-right: 40px;\n  margin-top: 60px;\n}\n\n@media (max-width: 1380px) {\n  .projects-heading-text {\n    font-size: 50px;\n    margin-top: 80px;\n  }\n  .projects-heading-sub-text {\n    font-size: 25px;\n  }\n}\n\n@media (max-width: 768px) {\n  .projects-heading-text {\n    font-size: 30px;\n    margin-top: 20px;\n  }\n\n  .projects-heading-sub-text {\n    font-size: 20px;\n  }\n\n  .projects-heading-div {\n    flex-direction: column;\n  }\n\n  .projects-header-detail-text {\n    font-size: 16px;\n    margin-right: 0px;\n    margin-left: 0px;\n    line-height: normal;\n    text-align: center;\n  }\n\n  .repo-cards-div-main {\n    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\n    margin-left: 10px;\n    margin-right: 10px;\n    margin-top: 30px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
